module.exports = __webpack_public_path__ + "static/media/BoxPlotQ2_5.7bc1dda3.svg";